/* @flow */

import type { NETGEM_API_V8_REQUEST_RESPONSE } from '../../v8/types/RequestResponse';

import { HeaderName } from '../../v8/constants/Headers';
import { buildHeaderList } from '../../v8/helpers/RequestHeaders';
import sendV8Request from '../../v8/requests/v8';
import { HttpMethod } from '../../v8/types/HttpMethod';

const sendPersonalDataGetRequest: (url: string, eTag: ?string, method: HttpMethod, authenticationToken: string | null, signal: ?AbortSignal) => Promise<NETGEM_API_V8_REQUEST_RESPONSE> = (
  url,
  eTag,
  method,
  authenticationToken,
  signal,
) => {
  const headerList = buildHeaderList(HeaderName.IfNoneMatch, eTag);
  return sendV8Request(url, authenticationToken, null, headerList, null, signal, null, method, true);
};

export default sendPersonalDataGetRequest;
